<template>
  <div :class="$style.itemTableContainerHeight">
    <AnnouncementWrapper
      v-if="showAnnouncement"
      caretPosition=""
      :class="$style.announcement"
      :customCaretClassName="$style.announcementCaretPosition"
      header="Interested in a device trust policy?"
      :localStorageKey="announcementLocalStorageKey"
      :mainActionLink="conditionalPolicyDeviceCertificates"
      mainActionText="learn more"
      :showDismiss="true"
      text="To use device-based conditions, the
                      devices need to have a JumpCloud
                      certificate installed on them. You can click
                      on the settings button to distribute
                      certificates."
    />
    <GlobalPolicyCollapsibleSection />
    <AuthNPoliciesGuidedSetup
      :class="$style.authNPoliciesCards"
    />
    <UpgradeNudge :class="$style.upgradeNudge" />
    <AuthNPoliciesItemTable
      :isMainActionDisabled="isMainActionDisabled"
      :useDropDownFilterComponent="FilterComponentConsts.AuthNPoliciesDropDownFilter"
      :viewport="viewport"
    />
  </div>
</template>

<script>
// Components
import AnnouncementWrapper from 'client/components/Announcement/AnnouncementWrapper.vue';
import AuthNPoliciesGuidedSetup from 'client/Security/AuthNPoliciesGuidedSetup/AuthNPoliciesGuidedSetup.vue';
import AuthNPoliciesItemTable from 'client/Security/AuthNPoliciesItemTable.vue';
import GlobalPolicyCollapsibleSection from 'client/Security/GlobalPolicyCollapsibleSection.vue';
import UpgradeNudge from 'client/components/Nudge/UpgradeNudge.vue';

// Mixins
import AuthNPoliciesCertificateSettingsMixin from 'client/Security/mixins/AuthNPoliciesCertificateSettingsMixin';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';

// Constants
import {
  FilterComponentConsts,
  LocalStorageConsts,
} from 'client/util/Constants';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

export default {
  name: 'AuthNPoliciesMainPanel',

  components: {
    AuthNPoliciesGuidedSetup,
    AuthNPoliciesItemTable,
    AnnouncementWrapper,
    GlobalPolicyCollapsibleSection,
    UpgradeNudge,
  },

  mixins: [MainPanelMixin, AuthNPoliciesCertificateSettingsMixin],

  data: () => ({
    announcementLocalStorageKey: LocalStorageConsts.authnpoliciesInstructionsSeen,
    conditionalPolicyDeviceCertificates: KbArticleUrls.conditionalPolicyDeviceCertificates,
    FilterComponentConsts,
  }),

  computed: {
    isMainActionDisabled() {
      return !!this.$route.params.id;
    },

    showAnnouncement() {
      if (this.getDeviceIdentificationEnabled === undefined) return false;
      return (!this.getDeviceIdentificationEnabled);
    },
  },

  async mounted() {
    await this.initializeCertificateSettings();
  },
};
</script>

<style module>

.authNPoliciesCards {
  padding: var(--jc-spacer-medium);
}

.itemTableContainerHeight {
  background-color: var(--jcWhite);
  height: 100%;
  min-height: 100vh;
  padding-bottom: var(--jc-spacer-large);
}

.announcement {
  position: absolute;
  right: 10px;
  top: 60px;
}

.announcementCaretPosition { right: 14px; }

.upgradeNudge {
  margin: 0 var(--jc-spacer-medium);
}
</style>
